// extracted by mini-css-extract-plugin
module.exports = {"heading":"Signin_heading__1m4MJ","signin_form":"Signin_signin_form__3yTGg","signin_form_field":"Signin_signin_form_field__lLOlN","paragraph":"Signin_paragraph__2_RGh"};